import React from "react";
import CrudList from "@/components/CrudList";

export default function Sites() {
  return (
    <CrudList
      title="Site Tambang"
      subtitle="Lokasi operasional dan koordinat pusat"
      endpoint="/sites"
      exportModule="sites"
      columns={[
        { key: "name", label: "Nama Site" },
        { key: "location", label: "Lokasi" },
        { key: "lat", label: "Lat" },
        { key: "lng", label: "Lng" },
        { key: "radius_m", label: "Radius", render: (r) => `${r.radius_m || 500}m` },
      ]}
      fields={[
        { key: "name", label: "Nama Site", required: true, wide: true },
        { key: "location", label: "Lokasi (Kabupaten/Provinsi)", wide: true },
        { key: "lat", label: "Latitude", type: "number", placeholder: "-3.325" },
        { key: "lng", label: "Longitude", type: "number", placeholder: "115.590" },
        { key: "radius_m", label: "Radius Geofence (meter)", type: "number", placeholder: "500", wide: true },
      ]}
    />
  );
}
